import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistorySection from 'Components/HistorySection';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import HistoryRowListing from 'Components/HistoryRowListing';

const optFormatter = (
  name: string | number,
  version?: IDocumentWithTypeV2<'inflammatoryDiseaseActivityStart'>['version'],
): React.JSX.Element => (
  <span>
    <FormattedMessage id={'inflammatoryDiseaseActivity.opts.' + name} />
    <span>
      &nbsp;
      {'('}
      <FormattedMessage id="inflammatoryDiseaseActivity.careGuidelines" />
      &nbsp;
      {version === '2024' ? '2024' : '2020'}
      {')'}
    </span>
  </span>
);

const StartHistory = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'inflammatoryDiseaseActivity.inflammatoryDiseaseActivityStart'} />}
      newButton={
        <DocumentCreationButton
          name="inflammatoryDiseaseActivityStart"
          text={'inflammatoryDiseaseActivity.newActivity'}
          onClick={startEdit({}, 'inflammatoryDiseaseActivityStart')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={12}>
              <FormattedMessage id={'inflammatoryDiseaseActivity.inflammatoryDiseaseActivity'} />
            </Item>
          </>
        }
        contentFormat={d => (
          <Item xs={12}>
            {d.inflammatoryDiseaseActivity ? optFormatter(d.inflammatoryDiseaseActivity, d.version) : '-'}
          </Item>
        )}
        makeDate
        makeControls
        historyRowControls={d => <HistoryRowControls document={d} startEdit={startEdit} view={view} />}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'inflammatoryDiseaseActivityStart'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default StartHistory;
